import { ChangeDetectorRef, Component, DoCheck, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { LayoutService } from "../../services/layouts/layout.service";
import { Translator } from "../../services/translator/translator.service";
import { userResponse } from "../../classes/userResponse/user-response";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadCrumbsComponent implements OnInit {
  opened: boolean = true;
  infobreadcrumb: any[] = [];
  currentRoute: string;
  breadarray: any[] = []; //string
  breadlength: number;
  translation: any;
  layoutservices: LayoutService;

  allData1: any[] = [];
  allData2: any[] = [];
  allData3: any[] = [];

  constructor(
    private autentificador: AuthenticationService,
    private router: Router,
    private _ruta: ActivatedRoute,
    private _layoutservices: LayoutService,
    private changeDetectorRef: ChangeDetectorRef,
    private translator: Translator
  ) {
    this.initializeTranslate();
    var breadcrumb: string[];
    var breadcrumb2: string[];
    var breadcrumb3: string[];

    this.layoutservices = _layoutservices;
    for (var i = 0; i < this.router.config.length; i++) {
      breadcrumb = [];
      if (this.router.config[i].data && this.router.config[i].data.breadcrumbs)
        this.router.config[i].data.breadcrumbs.forEach((element) => {
          breadcrumb.push(element);
        });
      this.allData1.push({
        path: "/" + this.router.config[i].path,
        breadcrumbs: breadcrumb,
      });
    }

    if (this.router.config[0])
      for (var i = 0; i < this.router.config[0].children.length; i++) {
        breadcrumb = [];
        if (
          this.router.config[0].children[i].data &&
          this.router.config[0].children[i].data.breadcrumbs
        )
          this.router.config[0].children[i].data.breadcrumbs.forEach(
            (element) => {
              breadcrumb.push(element);
            }
          );
        this.allData2.push({
          path: "/" + this.router.config[0].children[i].path,
          breadcrumbs: breadcrumb,
        });

        let breadcrumb2 = breadcrumb.slice();
        if (this.router.config[0].children[i].children) {
          for (
            var j = 0;
            j < this.router.config[0].children[i].children.length;
            j++
          ) {
            if (this.router.config[0].children[i].path == "Clientes")
              breadcrumb = breadcrumb2.slice();
            if (
              this.router.config[0].children[i].children[j].data &&
              this.router.config[0].children[i].children[j].data &&
              this.router.config[0].children[i].children[j].data.breadcrumbs
            )
              this.router.config[0].children[i].children[
                j
              ].data.breadcrumbs.forEach((element) => {
                breadcrumb.push(element);
              });

            //this.allData3.push({path:this.router.config[0].children[i].path +'_i='+i+'_/_'+ 'j='+j+'_'+this.router.config[0].children[i].children[j].path,
            this.allData3.push({
              path:
                "/" +
                this.router.config[0].children[i].path +
                "/" +
                this.router.config[0].children[i].children[j].path,

              breadcrumbs: breadcrumb,
            });
          }
        }
      }

    this.allData1.forEach((d) => this.infobreadcrumb.push(d));
    this.allData2.forEach((d) => this.infobreadcrumb.push(d));
    this.allData3.forEach((d) => this.infobreadcrumb.push(d));

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event["url"];
        let breadtmp;
        if (this.currentRoute.includes("/editar")) {
          breadtmp = this.infobreadcrumb.filter(
            (e) => e.path == "/Clientes/Cliente/editar/:id"
          );
        } else {
          breadtmp = this.infobreadcrumb.filter(
            (e) => e.path == this.currentRoute
          );
        }
        if (breadtmp && breadtmp[0] && breadtmp[0]["breadcrumbs"]) {
          this.breadarray = breadtmp[0]["breadcrumbs"];
          // Buscar nomes da API para substituir valores fixos
          // Estrutura esperada: [0] = "Inicio", [1] = Pai, [2] = Filho
          this.breadarray = this.breadarray.map((s, index) => {
            let crumbText = s["crumb"];
            
            // Primeiro item: "Inicio" - manter como está ou buscar da API se houver
            if (index === 0) {
              const nombreInicio = this.getNombreInicioFromAPI();
              if (nombreInicio) {
                crumbText = nombreInicio;
              }
            }
            // Segundo item: Módulo Pai (ex: "Configuración del proyecto")
            else if (index === 1) {
              const nombrePai = this.getNombrePaiFromAPI(this.currentRoute);
              if (nombrePai) {
                crumbText = nombrePai;
              }
            }
            // Terceiro item ou último: Módulo Filho (ex: "Traducciones y Textos", "ImpresionOnline")
            else {
              const nombreFilho = this.getNombreFilhoFromAPI(this.currentRoute);
              if (nombreFilho) {
                crumbText = nombreFilho;
              }
            }
            
            return {
              crumb: crumbText,
              urlcrumb: s["urlcrumb"],
            };
          });
        } else {
          this.breadarray = [];
        }
        this.breadlength = this.breadarray.length;
      }
    });

    _layoutservices.sidebar_opened.subscribe((o) => {
      this.opened = o;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnInit() {
    // this.initializeTranslate();
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }

  private normalizeCrumb(crumb: string): string {
    if (!crumb) {
      return "";
    }
    const cleaned = crumb.replace(/_/g, " ");
    return cleaned
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
      .trim();
  }

  clickCrumb(u) {
    this.layoutservices.urlclicked.emit(u);
  }

  /**
   * Busca o nome "Inicio" da API (se houver um módulo específico)
   * @returns Nome do módulo Inicio da API ou null
   */
  private getNombreInicioFromAPI(): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        
        const modulo = permisos.find(
          (p) => (p.Ventana && p.Ventana.trim().toLowerCase() === "/portada") && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        if (modulo) {
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  /**
   * Busca o nome do módulo PAI nas permissões da API
   * Para rotas de configuración, busca o módulo 223 (CONFIGURACION)
   * @param currentRoute Rota atual
   * @returns Nome do módulo pai (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombrePaiFromAPI(currentRoute: string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        
        const routeLower = (currentRoute || "").trim().toLowerCase();
        
        // Para rotas de configuración, buscar módulo 223 (CONFIGURACION - pai)
        if (routeLower.includes("/configuracion/")) {
          const modulo = permisos.find(
            (p) => p.ModuloId == 223 && p.NombreAccion.trim().toUpperCase() == "VER"
          );
          if (modulo) {
            return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
              ? modulo.NombreModuloIdioma 
              : modulo.NombreModulo || null;
          }
        }
        
        // Para outras rotas, buscar o módulo pai baseado no ModuloIdPadre do módulo filho
        const moduloFilho = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === routeLower && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        
        if (moduloFilho && moduloFilho.ModuloIdPadre) {
          const moduloPai = permisos.find(
            (p) => p.ModuloId == moduloFilho.ModuloIdPadre && 
                   p.NombreAccion.trim().toUpperCase() == "VER"
          );
          if (moduloPai) {
            return moduloPai.NombreModuloIdioma && moduloPai.NombreModuloIdioma.trim() !== "" 
              ? moduloPai.NombreModuloIdioma 
              : moduloPai.NombreModulo || null;
          }
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  /**
   * Busca o nome do módulo FILHO nas permissões da API baseado na rota atual
   * @param currentRoute Rota atual
   * @returns Nome do módulo filho (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombreFilhoFromAPI(currentRoute: string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        
        const routeLower = (currentRoute || "").trim().toLowerCase();
        
        // Buscar por rota exata primeiro
        let modulo = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === routeLower && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        
        // Se não encontrar, buscar por rota parcial (para casos como /configuracion/traducciones)
        if (!modulo) {
          modulo = permisos.find(
            (p) => p.Ventana && p.Ventana.trim().toLowerCase().includes(routeLower) && 
                   p.NombreAccion.trim().toUpperCase() == "VER"
          );
        }
        
        // Fallback: buscar por rotas conhecidas
        if (!modulo) {
          if (routeLower.includes("/configuracion/traducciones")) {
            modulo = permisos.find(
              (p) => p.Ventana && p.Ventana.trim().toLowerCase() === "/configuracion/traducciones" && 
                     p.NombreAccion.trim().toUpperCase() == "VER"
            );
          } else if (routeLower.includes("/configuracion/impresiononline")) {
            modulo = permisos.find(
              (p) => p.Ventana && p.Ventana.trim().toLowerCase() === "/configuracion/impresiononline" && 
                     p.NombreAccion.trim().toUpperCase() == "VER"
            );
          }
        }
        
        if (modulo) {
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }
}
